import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import KreditaLogo from './KreditaLogo';
import { useLanguage } from '../contexts/LanguageContext';
const Footer = () => {
  const {
    t
  } = useLanguage();
  return <footer className="bg-gray-900 text-white" data-id="element-73">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-74">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-75">
          {/* Brand Column */}
          <div className="md:col-span-1" data-id="element-76">
            <div className="text-white mb-4" data-id="element-77">
              <KreditaLogo data-id="element-78" />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed" data-id="element-79">
              {t.footer.description}
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-80">
            <h3 className="text-lg font-semibold mb-4" data-id="element-81">{t.footer.explore}</h3>
            <ul className="space-y-2" data-id="element-82">
              <li data-id="element-83">
                <Link to="/" className="text-gray-400 hover:text-primary transition-colors text-sm" data-id="element-84">
                  {t.nav.home}
                </Link>
              </li>
              <li data-id="element-85">
                <Link to="/browse" className="text-gray-400 hover:text-primary transition-colors text-sm" data-id="element-86">
                  {t.nav.browse}
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/create-listing" className="text-gray-400 hover:text-primary transition-colors text-sm" data-id="element-88">
                  {t.nav.listProperty}
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/license-plans" className="text-gray-400 hover:text-primary transition-colors text-sm" data-id="element-90">
                  Planos
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-91">
            <h3 className="text-lg font-semibold mb-4" data-id="element-92">{t.footer.services}</h3>
            <ul className="space-y-2" data-id="element-93">
              <li data-id="element-94">
                <Link to="/services" className="text-gray-400 hover:text-primary transition-colors text-sm" data-id="element-95">
                  {t.services.photography.title}
                </Link>
              </li>
              <li data-id="element-96">
                <Link to="/services" className="text-gray-400 hover:text-primary transition-colors text-sm" data-id="element-97">
                  {t.services.valuation.title}
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/dashboard" className="text-gray-400 hover:text-primary transition-colors text-sm" data-id="element-99">
                  {t.nav.dashboard}
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/login" className="text-gray-400 hover:text-primary transition-colors text-sm" data-id="element-101">
                  {t.nav.login}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-102">
            <h3 className="text-lg font-semibold mb-4" data-id="element-103">{t.footer.contact}</h3>
            <div className="space-y-3" data-id="element-104">
              <div className="flex items-start" data-id="element-105">
                <PhoneIcon className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" data-id="element-106" />
                <span className="text-sm text-gray-400" data-id="element-107">(123) 456-7890</span>
              </div>
              <div className="flex items-start" data-id="element-108">
                <MailIcon className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" data-id="element-109" />
                <span className="text-sm text-gray-400" data-id="element-110">hello@kredita.com</span>
              </div>
              <div className="flex items-start" data-id="element-111">
                <MapPinIcon className="h-5 w-5 text-primary mr-3 flex-shrink-0 mt-0.5" data-id="element-112" />
                <span className="text-sm text-gray-400" data-id="element-113">
                  123 Real Estate Ave
                  <br data-id="element-114" />
                  Suite 100, City, ST 12345
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800" data-id="element-115">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-116">
            <p className="text-sm text-gray-400" data-id="element-117">
              &copy; {new Date().getFullYear()} Kredita.{' '}
              {t.footer.allRightsReserved}
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-118">
              <Link to="#" className="text-sm text-gray-400 hover:text-primary transition-colors" data-id="element-119">
                {t.footer.privacyPolicy}
              </Link>
              <Link to="#" className="text-sm text-gray-400 hover:text-primary transition-colors" data-id="element-120">
                {t.footer.termsOfService}
              </Link>
              <Link to="#" className="text-sm text-gray-400 hover:text-primary transition-colors" data-id="element-121">
                {t.footer.cookiePolicy}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;